module.exports = __webpack_public_path__ + "static/img/bg-tr.9f7e79b7.webp";